import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WorkflowContextService } from './services';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { PlatformLocation } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import initSwitcher from 'favicon-switcher';
import * as FullStory from '@fullstory/browser';
import { environment } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmComponent } from './components/system/modal-confirm/modal-confirm.component';
import { IconService } from './services/icon-service/icon.service';
// Added by Amisha on 2026-06-12.
// Reason: expose the shared Janus AppView leave-confirmation state at the root
// component so the common shell guard has a stable modal host.
import { AppViewLeaveConfirmationService } from './services/app-view-leave-confirmation.service';
import { Subscription } from 'rxjs';
import { getSafeReturnPath } from './services/utilities/return-url';
declare var gtag: Function;

initSwitcher();

@Component({
  selector: 'wm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'app-cli';

  @ViewChild('updateVersion', { static: true })
  updateVersion: ModalConfirmComponent;

  loggedInSub: Subscription;

  constructor(
    private _context: WorkflowContextService,
    private route: ActivatedRoute,
    private router: Router,
    private location: PlatformLocation,
    private modalService: NgbModal,
    private titleService: Title,
    private _toastrSvc: ToastrService,
    // Added by Amisha on 2026-06-12.
    // Reason: root-level modal hosting is required for common Janus shell navigation prompts.
    public appViewLeaveConfirmationService: AppViewLeaveConfirmationService,
    // [START]- 2025-10-29
    // Author: Ketan Shetye
    // -------------------
    private iconService: IconService
  ) // -------------------
  // [END] - 2025-10-29
  {
    FullStory.init({
      orgId: 'TFM44',
      devMode: !environment.production
    });
    // [START]- 2025-10-29
    // Author: Ketan Shetye
    // -------------------
    this.iconService.registerAll();
    // -------------------
    // [END] - 2025-10-29
  }

  ngOnInit() {
    // close all modals on state change
    this.location.onPopState(() => {
      this.modalService.dismissAll();
    });
    this.router.events
      .pipe(
        filter((event, index) => event instanceof NavigationEnd),
        map(() => this.route),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(event => {
        gtag('config', 'G-8WXD7G4EVD', { page_path: event.urlAfterRedirects });

        let title = 'GeoPermits';

        if (event['title']) {
          title = `${title} - ${event['title']}`;
        }
        this.titleService.setTitle(title);
      });

    this.route.queryParams.subscribe(params => {
      let returnUrl = params['returnUrl'];

      if (this._context) {
        this.loggedInSub = this._context.isLoggedIn$.subscribe((loggedIn: boolean) => {
          if (loggedIn && returnUrl) {
            // Only follow return URLs that point to this app, so a crafted link
            // cannot send the user to another site after login (open redirect).
            const safePath = getSafeReturnPath(returnUrl);
            if (safePath) {
              if (/^https?:/i.test(String(returnUrl).trim())) {
                // absolute URL on this app: keep the full page navigation used
                // before, because the login component also navigates to '/' after
                // login and a router navigation here would be overridden by it
                window.location.href = window.location.origin + safePath;
              } else {
                this.router.navigateByUrl(safePath);
              }
            }
            returnUrl = '';
          } else if (!loggedIn) {
            this.router.navigate(['/']);
          }
        });
      }
    });

    // The returnUrl captured in the queryParams is 
    // lost when the user clicks the back button from 
    // the login page, so the redirect in the loggedInSub
    // will be irrelevant. Unsubscribe from it when that 
    // happens to prevent unintended redirects.
    //
    // We don't actually know what the loggedInSub was intended to do.
    this.location.onPopState(() => {
      if (this.loggedInSub) {
        this.loggedInSub.unsubscribe();
      }
    });

    this._context.needsReload$.subscribe(result => {
      if (result) {
        this.updateVersion.open();
      }
    });
  }

  reloadSite() {
    window.location.href = window.location.href;
  }

}